// extracted by mini-css-extract-plugin
export var dropdownIcon = "_qq-6";
export var imgContainer = "_qq-3";
export var menuIcon = "_qq-5";
export var pillWrapper = "_qq-2";
export var pillsContainer = "_qq-1";
export var subscriptionCard = "_qq-0";
export var subscriptionLogo = "_qq-4";